/* eslint-disable no-return-assign */
import { Spin } from 'antd';
import React, { FC, Fragment } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styles/styled-components';
import { ApplicationRootState } from 'types';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { Viewport } from 'components/ViewportProvider';
import { selectBuyer } from 'containers/MainLayout/selectors';
import { Buyer } from 'types/schema';
import media from 'utils/mediaStyle';
import { ContactUsForm as IContactUsForm } from '../../ContactUsPage/types.d';
import ContactUs from './components/ContactUs';
import ProductsSource from './components/ProductsSource';

import reducer from './reducer';
import saga from './saga';
// import { FormattedMessage } from 'react-intl';
import FreshJourney from './components/FreshJourney';
import StandardSolution from './components/StandardSolution';
import { ESSENTIAL_BANNER, ESSENTIAL_BANNER_EN, ESSENTIAL_BANNER_MOBILE, ESSENTIAL_BANNER_MOBILE_EN } from './Images';
import { commonDimensions } from 'utils/constants';
import Banner from '../FarmToTablePage/components/Banner';
import translations from 'translations';
import messages from './messages';

const Spinner = styled(Spin)`
  top: calc(100vh / 2) !important;
  transform: translateY(-50%) !important;
`;

const Container = styled.div`
  position: relative;
  margin-top: 100px;
  ${media.md`
  margin-top: 106px;
  }
  `}
  ${media.lg`
  margin-left: -40px;
  margin-right: -40px;
  }
  
  `}
`;

const BannerContainer = styled.div``;

const BannerImage = styled.div`
  position: relative;
  background-image: ${({ img }) => `url(${img})`};
  padding-top: 21%;
  width: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  @media (max-width: 1023px) {
    padding-top: 43%;
  }
`;

const BottomBannerWrapper = styled.div`
  margin-top: -20px;
  & > div {
    padding-top: 0px;
    background: #ffffff;
  }
  & > div > div {
    max-width: ${commonDimensions.MAX_WIDTH_CONTAINER}px;
    margin: 0 auto;
    padding: 0 40px;
    @media (max-width: 991px) {
      margin-top: 16px;
      padding: 0px;
    }
  }
  & > div > div > div {
    max-width: 100%;
  }
  #buy-from-favorite {
    display: flex;
    align-items: center;
    padding: 21px 20px;
    justify-content: center;
  }
  #buy-from-favorite ~ button {
    justify-content: center;
  }
`;

export interface IStateProps {
  buyer: Buyer;
}

interface IDispatchProps {
  onCheckEmail: (email: string) => void;
  onSubmit: (data: { values: IContactUsForm; cb: () => void }) => void;
}

type Props = IStateProps & IDispatchProps & RouteComponentProps;

const KamereoEssentialPage: FC<Props> = () => {
  const lang = localStorage.getItem('lang') || 'vi';
  const loggedIn = !!localStorage.getItem('token');
  return (
    <Fragment>
      <Spinner spinning={false}>
        <Container>
          <Viewport.Consumer>
            {({ width }) => (
              <BannerContainer>
                {width > 991 ? (
                  <BannerImage img={lang === 'vi' ? ESSENTIAL_BANNER : ESSENTIAL_BANNER_EN} />
                ) : (
                  <BannerImage img={lang === 'vi' ? ESSENTIAL_BANNER_MOBILE : ESSENTIAL_BANNER_MOBILE_EN} />
                )}
              </BannerContainer>
            )}
          </Viewport.Consumer>
          <FreshJourney />
          <div id="PRODUCT_CATEGORY">
            <ProductsSource />
          </div>
          <StandardSolution />
          {loggedIn && (
            <BottomBannerWrapper>
              <Banner
                customButton={{
                  text: translations(messages.exploreKamereoFresh),
                  link: '/kamereo-ngon',
                }}
              />
            </BottomBannerWrapper>
          )}
          {!loggedIn && <ContactUs />}
        </Container>
      </Spinner>
    </Fragment>
  );
};

const mapStateToProps = createStructuredSelector<ApplicationRootState, IStateProps>({
  buyer: selectBuyer(),
});

const withConnect = connect(mapStateToProps, () => {});

const withReducer = injectReducer({
  key: 'kamereoEssentialPage',
  reducer: reducer,
});

const withSaga = injectSaga({ key: 'kamereoEssentialPage', saga: saga });

export default compose(withConnect, withReducer, withSaga)(KamereoEssentialPage);
